import React from "react";
import { useIntl } from "react-intl";
import Layout from "../components/features/Default/layout/layout";

const Refund = () => {
  const intl = useIntl();
  return (
    <Layout pageProps={{ title: intl.formatMessage({ id: "footer.policy.refund" }) }}>
      <div className="box-cover sm:w-screen md:w-full">
        <div className="text-center">
          <span className="font-bold uppercase text-[24px]">
            Chính sách đổi trả
          </span>
        </div>
        <div className="py-2 px-4">
          <span className="">
            <b className="pr-1">JlptUp.com</b>
            cung cấp sản phẩm kỹ thuật số như một đơn vị tiền tệ trên website -
            Kim cương - để đáp ứng nhu cầu trải nghiệm những tính năng nâng cao
            có tính phí của người dùng.
          </span>
        </div>
        <div className="py-2 px-4">
          <span>
            <b className="pr-1">JlptUp.com</b> không hoàn tiền mặt và đổi trả
            dưới bất kỳ tình huống nào.
          </span>
        </div>
        <div className="py-2 px-4">
          <i>
            Mọi thắc mắc hay gặp khó khăn trong quá trình trải nghiệm website
            vui lòng liên hệ với JlptUp.com qua hộp thư thoại ngay trên website
            hoặc qua fanpage:
            <a
              className="underline text-primary pl-1"
              href="https://www.facebook.com/fb.jlptup.com"
            >
              Jlpt Up.
            </a>
          </i>
        </div>
      </div>
    </Layout>
  );
};

export default Refund;
